import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { DocumentStatusIcons } from "@components/documents/DocumentStatusIcons";
import { useDocumentStatusNavigation } from "@components/documents/useDocumentStatusNavigation";
import { useIsFinancialDocumentsTableReadonly } from "../useIsFinancialDocumentsTableReadonly";

export const DocumentStatusCell = memo(
    ({
        row,
        table,
    }: CellContext<ViewTableFeatures, FinancialDocumentListItem, unknown>) => {
        const document = row.original;
        const isTableReadonly = useIsFinancialDocumentsTableReadonly(table);
        const callbacks = useDocumentStatusNavigation(document);

        return (
            <ViewTableCell>
                {isTableReadonly ? (
                    <DocumentStatusIcons document={document} />
                ) : (
                    <DocumentStatusIcons document={document} {...callbacks} />
                )}
            </ViewTableCell>
        );
    },
);
DocumentStatusCell.displayName = "DocumentStatusCell";
